import { Injectable } from '@angular/core';
import { CambioBreakevenParams } from './cambio-breakeven-params';
import { VolumeExtended } from 'src/app/core/models/extended/volume-extended';
import { CambioTendenzialeTermineParams } from './cambio-tendenziale-termine-params';
import { EsposizioneNetta } from 'src/app/core/models/enum/esposizione-netta';
import { CalcoloOutrightParams } from './calcolo-outright-params';

@Injectable({ providedIn: 'root' })
export class VolumiService {

  constructor() { }

  calcolaCambioBreakEven(params: CambioBreakevenParams) {
    const dataLimite = this.getDataLimiteVolumi();
    let esposizioneNettaRimanenteBudget = 0;
    let esposizioneRealizzata = 0;
    let controvaloreEsposizioneRealizzata = 0;
    let utiliPerditeRealizzateCoperture = 0;
    params.volumi.forEach(v => {
      if (v.data < dataLimite) {
        esposizioneRealizzata += v.volumeNettoRealizzatoSecondaValuta ? v.volumeNettoRealizzatoSecondaValuta : 0;
        controvaloreEsposizioneRealizzata += v.volumeNettoRealizzatoPrimaValuta ? v.volumeNettoRealizzatoPrimaValuta : 0;
        utiliPerditeRealizzateCoperture += v.utiliPerditeRealizzatiCopertureChiuse ? v.utiliPerditeRealizzatiCopertureChiuse : 0;
        utiliPerditeRealizzateCoperture += v.utiliPerditeRealizzatiCopertureScadute ? v.utiliPerditeRealizzatiCopertureScadute : 0;
      } else {
        esposizioneNettaRimanenteBudget += v.volumeNetto ? v.volumeNetto : 0;
      }
    });
    const budgetInizialePrevisto = Math.abs(this.calcolaBudgetIniziale(params.volumi));
    esposizioneRealizzata = Math.abs(esposizioneRealizzata);
    esposizioneNettaRimanenteBudget = Math.abs(esposizioneNettaRimanenteBudget);
    controvaloreEsposizioneRealizzata = Math.abs(controvaloreEsposizioneRealizzata);

    const esposizioneRealizzataConPrevisionale = esposizioneNettaRimanenteBudget + esposizioneRealizzata;
    const variazioneVolumiSecondaValuta = esposizioneRealizzataConPrevisionale - budgetInizialePrevisto;
    const budgetDaRealizzarsi = esposizioneNettaRimanenteBudget - variazioneVolumiSecondaValuta;
    const controvaloreFlussoRiferimento = budgetInizialePrevisto / params.cambioObiettivo;
    const isExport = params.esposizioneNetta === EsposizioneNetta.EXPORT;
    let controvaloreRealizzatoUtilePerdita = isExport ? controvaloreEsposizioneRealizzata + utiliPerditeRealizzateCoperture :
    controvaloreEsposizioneRealizzata - utiliPerditeRealizzateCoperture;
    const controvalore = controvaloreFlussoRiferimento - controvaloreRealizzatoUtilePerdita;

    return budgetDaRealizzarsi / controvalore;
  }

  getDataLimiteVolumi() {
    const dataLimite = new Date();
    // dataLimite.setDate(dataLimite.getDate() + 2);
    return dataLimite;
  }

  calcolaBudgetIniziale(volumi: VolumeExtended[]) {
    let budgetInizialePrevisto = 0;
    volumi.forEach(v => {
      budgetInizialePrevisto += v.volumeNetto;
    });
    return budgetInizialePrevisto;
  }

  calcolaCambioTendenzialeAlCambioATermine(params: CambioTendenzialeTermineParams) {
    const dataLimite = this.getDataLimiteVolumi();
    let budgetIniziale = 0;
    let flussiNettiRealizzati = 0;
    let controvaloreFlussiNettiRealizzati = 0;
    let utiliPerditeRealizzate = 0;
    let volumeCambioATermine = 0;
    let volumeNettoPrevisionale = 0;
    params.volumi.forEach(v => {
      budgetIniziale += v.volumeNetto;
      if (v.data > dataLimite) {
        volumeNettoPrevisionale += v.volumeNetto;
        const meseForward = this.getMonthForForward(new Date(), v.data);
        const outright = this.calcolaOutrightFromForwards({
          forwards: params.forwards,
          cambioSpot: params.cambioSpot,
          meseForward: meseForward  
        });
        volumeCambioATermine += v.volumeNetto / outright;
      } else {
        flussiNettiRealizzati += v.volumeNettoRealizzatoSecondaValuta;
        controvaloreFlussiNettiRealizzati += v.volumeNettoRealizzatoPrimaValuta;
        utiliPerditeRealizzate += v.utiliPerditeRealizzatiCopertureScadute ? v.utiliPerditeRealizzatiCopertureScadute : 0;
        utiliPerditeRealizzate += v.utiliPerditeRealizzatiCopertureChiuse ? v.utiliPerditeRealizzatiCopertureChiuse : 0;
      }
    });

    let cambioRealizzatoConUtiliPerditeCoperture = 0;
    let cambioTendenzialeCambioATermine = 0;
    if (params.esposizioneNetta === EsposizioneNetta.IMPORT) {
      cambioRealizzatoConUtiliPerditeCoperture = controvaloreFlussiNettiRealizzati - utiliPerditeRealizzate ? 
        flussiNettiRealizzati / (controvaloreFlussiNettiRealizzati - utiliPerditeRealizzate) : 0;
      cambioTendenzialeCambioATermine = (flussiNettiRealizzati - volumeNettoPrevisionale) / (controvaloreFlussiNettiRealizzati -
        utiliPerditeRealizzate - volumeCambioATermine);
    } else {
      cambioRealizzatoConUtiliPerditeCoperture = controvaloreFlussiNettiRealizzati + utiliPerditeRealizzate ? 
        flussiNettiRealizzati / (controvaloreFlussiNettiRealizzati + utiliPerditeRealizzate) : 0;
      cambioTendenzialeCambioATermine = (volumeNettoPrevisionale + flussiNettiRealizzati) / (volumeCambioATermine + 
        controvaloreFlussiNettiRealizzati + utiliPerditeRealizzate);
    }
    return cambioTendenzialeCambioATermine;
  }

  getMonthForForward(minDate: Date, maxDate: Date) {
    let months: number;
    months = (maxDate.getFullYear() - minDate.getFullYear()) * 12;
    months -= minDate.getMonth();
    months += maxDate.getMonth();
    return months < 0 ? -1 : months;
  }

  calcolaOutrightFromForwards(params: CalcoloOutrightParams) {
    const forward = params.forwards.filter(function (forward) {
      return forward.mese === params.meseForward;
    })[0];
    return forward ? forward.forward + params.cambioSpot : null;
  }

}
